<template>
  <div class="containe">
    <div class="popup">
      <div class="popup_header flex mb_20">
        <div class="popup_search flex">
          <div class="w_220 mr_20">
            <el-input v-model="tableParams.name"
                      placeholder="名称、城市、编码"
                      @keyup.enter.native="getTableDataSearch()"></el-input>
          </div>
          <el-button @click="getTableDataSearch()"
                     type="primary">搜索</el-button>
          <el-button @click="resetTableData"
                     type="danger">重置</el-button>
        </div>
      </div>
      <div class="popup_main">
        <el-table :data="tableData"
                  border
                  style="width: 100%"
                  class="mb_20">
          <el-table-column prop="name"
                           label="报关口岸"
                           width="180"></el-table-column>
          <el-table-column prop="code"
                           label="编码"
                           width="180"></el-table-column>
          <!-- <el-table-column prop="city"
                           label="城市"></el-table-column> -->
          <el-table-column label="操作">
            <template slot-scope="r">
              <el-button @click="leaveSelected(r.row)"
                         type="text">选定</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="update_page_wrap flex justify_end">
          <el-pagination @current-change="pageChange"
                         background
                         layout="total, prev, pager, next"
                         :total="tableTotal"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tableData: [],
      exit_dialog: false,
      tableParams: {
        pageNum: 1,
        pageSize: 10,
        name: '',
      },
      tableTotal: 0,
    };
  },
  created () {
    this.getTableData();
  },
  methods: {
    leaveSelected (r) {
      this.$emit('leaveSelected', r);
    },
    resetTableData () {
      this.tableParams = {
        pageNum: 1,
        pageSize: 10,
        name: '',
      };
      this.getTableData();
    },
    pageChange (i) {
      this.tableParams.pageNum = i;
      this.getTableData();
    },
    getTableDataSearch(){
      this.tableParams.pageNum = 1;
      this.getTableData();
    },
    getTableData () {
      this.$axios
        .get("/user/leavePort/getPage", {
          params: this.tableParams,
        })
        .then(res => {
          if (res.status == 200) {
            this.tableData = res.data.list.list;
            this.tableTotal = res.data.list.total;
          }
        });
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/portLeave.vue